const initialState = {
  projects: null,
  project: null,
  project_catalogue: null,
  projectVR: null,
  removeVr: null,
  addReelResponse: null,
  projectVideos: null,
  priceList: null,
  projectAR: null,
  arList: null,
  reelsList: null,
  reelDetail: null,
  bookingAvailableLoading: false,
  arLoading: false,
  listLoading: false,
  detailLoading: false,
  editLoading: false,
  vrLoading: false,
  reelLoading: false,
  reelsLoading: false,
  videoLoading: false,
  priceLoading: false,
  projectLocalities: null,
  localities: null,
  localitiesLoading: false,
};


export const projectReducer = (state = initialState, action) => {
  switch (action.type) {

    case "GET_PROJECTS_LIST_REQUEST":
      return {
        ...state,
        listLoading: true,
      };

    case "GET_PROJECTS_LIST_SUCCESS":
      return {
        ...state,
        listLoading: false,
        projects: action.payload,
      };

    case "GET_PROJECTS_LIST_FAILED":
      return {
        ...state,
        listLoading: false,
      };

    case "EDIT_PROJECT_REQUEST":
      return {
        ...state,
        editLoading: true,
      };

    case "EDIT_PROJECT_SUCCESS":
    case "EDIT_PROJECT_FAILED":
      return {
        ...state,
        editLoading: false,
        project: action.payload,
      };

    case "GET_PROJECT_REQUEST":
      return {
        ...state,
        detailLoading: true,
      };

    case "GET_PROJECT_SUCCESS":
      return {
        ...state,
        detailLoading: false,
        project: action.payload,
      };

    case "GET_PROJECT_FAILED":
      return {
        ...state,
        detailLoading: false,
        project: action.payload,
      };

    case "GET_PROJECT_CATALOGUE_REQUEST":
      return {
        ...state,
        detailLoading: true,
      };

    case "GET_PROJECT_CATALOGUE_SUCCESS":
    case "GET_PROJECT_CATALOGUE_FAILED":
      return {
        ...state,
        detailLoading: false,
        project_catalogue: action.payload,
      };

    case "ADD_VR_REQUEST":
    case "REMOVE_VR_REQUEST":
      return {
        ...state,
        vrLoading: true,
      };

    case "ADD_VR_SUCCESS":
    case "ADD_VR_FAILED":
      return {
        ...state,
        vrLoading: false,
        projectVR: action.payload,
      };

    case "REMOVE_VR_SUCCESS":
    case "REMOVE_VR_FAILED":
      return {
        ...state,
        vrLoading: false,
        removeVr: action.payload,
      };

    case "ADD_LANDMARK_REQUEST":
      return {
        ...state,
        detailLoading: true,
      };

    case "ADD_LANDMARK_SUCCESS":
    case "ADD_LANDMARK_FAILED":
      return {
        ...state,
        detailLoading: false,
        project: action.payload,
      };

    case "ADD_REEL_REQUEST":
      return {
        ...state,
        reelLoading: true,
      };

    case "ADD_REEL_SUCCESS":
    case "ADD_REEL_FAILED":
      return {
        ...state,
        reelLoading: false,
        addReelResponse: action.payload,
      };

    case "VIEW_PROJECT_VIDEOS_REQUEST":
    case "REMOVE_PROJECT_VIDEO_REQUEST":
      return {
        ...state,
        videoLoading: true,
      };

    case "VIEW_PROJECT_VIDEOS_SUCCESS":
      return {
        ...state,
        videoLoading: false,
        project: {
          ...state.project,
          data: {
            ...state.project?.data,
            builder_videos: action.payload.data,
          },
        },
      };

    case "EDIT_BOOKING_AVAILABLE_REQUEST":
      return {
        ...state,
        bookingLoading: true,
        editLoading: true,
      };

    case "EDIT_BOOKING_AVAILABLE_SUCCESS":
      return {
        ...state,
        bookingLoading: false,
        editLoading: false,
        project: {
          ...state.project,
          data: {
            ...state.project?.data,
            booking_available: action.payload.data?.booking_available || true,
          },
        },
      };

    case "EDIT_BOOKING_AVAILABLE_FAILED":
      return {
        ...state,
        bookingLoading: false,
        editLoading: false,
      };

    case "ADD_THREE_SIXTY_PREV_VIDEO_REQUEST":
    case "UPDATE_THREE_SIXTY_PREV_VIDEO_REQUEST":
      return {
        ...state,
        threeSixtyVideoLoading: true,
      };

    case "ADD_THREE_SIXTY_PREV_VIDEO_SUCCESS":
    case "UPDATE_THREE_SIXTY_PREV_VIDEO_SUCCESS":
      return {
        ...state,
        threeSixtyVideoLoading: false,
        threeSixtyPrevVideo: action.payload,
      };

    case "ADD_THREE_SIXTY_PREV_VIDEO_FAILED":
    case "UPDATE_THREE_SIXTY_PREV_VIDEO_FAILED":
      return {
        ...state,
        threeSixtyVideoLoading: false,
      };


    case "ADD_REELS_REQUEST":
    case "UPDATE_REELS_REQUEST":
    case "LIST_REELS_REQUEST":
    case "VIEW_REELS_REQUEST":
      return {
        ...state,
        reelsLoading: true,
      };

    case "ADD_REELS_SUCCESS":
      return {
        ...state,
        reelsLoading: false,
        addReelResponse: action.payload,
      };

    case "UPDATE_REELS_SUCCESS":
      return {
        ...state,
        reelsLoading: false,
        addReelResponse: action.payload, // reuse same response state
      };

    case "LIST_REELS_SUCCESS":
      return {
        ...state,
        reelsLoading: false,
        reelsList: action.payload,
      };

    case "VIEW_REELS_SUCCESS":
      return {
        ...state,
        reelsLoading: false,
        reelDetail: action.payload,
      };

    case "ADD_REELS_FAILED":
    case "UPDATE_REELS_FAILED":
    case "LIST_REELS_FAILED":
    case "VIEW_REELS_FAILED":
      return {
        ...state,
        reelsLoading: false,
      };

    case "STOP_LOADING":
      return {
        ...state,
        arLoading: false,
        listLoading: false,
        detailLoading: false,
        editLoading: false,
        vrLoading: false,
        reelLoading: false,
        videoLoading: false,
        priceLoading: false,
        bookingLoading: false,
        localitiesLoading: false,
        updateLocalitiesLoading: false,
        threeSixtyVideoLoading: false,
        reelsLoading: false,
      };

    case "VIEW_PROJECT_VIDEOS_FAILED":
    case "REMOVE_PROJECT_VIDEO_FAILED":
      return {
        ...state,
        videoLoading: false,
      };

    case "REMOVE_PROJECT_VIDEO_SUCCESS":
      return {
        ...state,
        videoLoading: false,
        removeVideo: action.payload,
      };

    case "SHOW_PRICELIST_REQUEST":
    case "UPDATE_PRICELIST_REQUEST":
      return {
        ...state,
        priceLoading: true,
      };

    case "SHOW_PRICELIST_SUCCESS":
    case "UPDATE_PRICELIST_SUCCESS":
      return {
        ...state,
        priceLoading: false,
        priceList: action.payload,
      };

    case "SHOW_PRICELIST_FAILED":
    case "UPDATE_PRICELIST_FAILURE":
      return {
        ...state,
        priceLoading: false,
        error: action.payload,
      };

    case "ADD_AR_REQUEST":
    case "LIST_AR_REQUEST":
    case "VIEW_AR_REQUEST":
    case "UPDATE_AR_REQUEST":
    case "DELETE_AR_REQUEST":
    case "DELETE_SPECIFIC_AR_REQUEST":
      return {
        ...state,
        arLoading: true,
      };

    case "ADD_AR_SUCCESS":
      return {
        ...state,
        arLoading: false,
        projectAR: action.payload,
      };

    case "LIST_AR_SUCCESS":
      return {
        ...state,
        arLoading: false,
        arList: action.payload,
      };

    case "VIEW_AR_SUCCESS":
      return {
        ...state,
        arLoading: false,
        projectAR: {
          ...state.projectAR,
          data: {
            ...state.projectAR?.data,
            project_ar: action.payload.data,
          },
        },
      };

    case "UPDATE_AR_SUCCESS":
      return {
        ...state,
        arLoading: false,
        projectAR: action.payload,
      };

    case "DELETE_AR_SUCCESS":
    case "DELETE_SPECIFIC_AR_SUCCESS":
      return {
        ...state,
        arLoading: false,
        projectAR: action.payload,
      };

    case "ADD_AR_FAILED":
    case "LIST_AR_FAILED":
    case "VIEW_AR_FAILED":
    case "UPDATE_AR_FAILED":
    case "DELETE_AR_FAILED":
    case "DELETE_SPECIFIC_AR_FAILED":
      return {
        ...state,
        arLoading: false,
      };

    case "GET_PROJECT_LOCALITIES_REQUEST":
      return {
        ...state,
        localitiesLoading: true,
      };

    case "GET_PROJECT_LOCALITIES_SUCCESS":
      return {
        ...state,
        localitiesLoading: false,
        projectLocalities: action.payload,
      };

    case "GET_PROJECT_LOCALITIES_FAILED":
      return {
        ...state,
        localitiesLoading: false,
      };

    case "UPDATE_PROJECT_LOCALITIES_REQUEST":
      return {
        ...state,
        updateLocalitiesLoading: true,
      };

    case "UPDATE_PROJECT_LOCALITIES_SUCCESS":
    case "UPDATE_PROJECT_LOCALITIES_FAILED":
      return {
        ...state,
        updateLocalitiesLoading: false,
        projectLocalities: action.payload,
      };

    case "GET_LOCALITY_REQUEST":
      return {
        ...state,
        localitiesLoading: true,
      };

    case "GET_LOCALITY_SUCCESS":
      return {
        ...state,
        localitiesLoading: false,
        localities: action.payload,
      };

    case "GET_LOCALITY_FAILED":
      return {
        ...state,
        localitiesLoading: false,
        localities: action.payload || null,
      };

    default:
      return state;
  }
};
